import {lazy} from 'react';

export const MultimediaImageLazy = lazy(() => import(/* webpackChunkName: "multimediaImage" */ '.'));
